import { render } from "./dashboard_admin_utils.vue?vue&type=template&id=611e4fa9&scoped=true"
import script from "./dashboard_admin_utils.vue?vue&type=script&lang=js"
export * from "./dashboard_admin_utils.vue?vue&type=script&lang=js"

import "./dashboard_admin_utils.vue?vue&type=style&index=0&id=611e4fa9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-611e4fa9"]])

export default __exports__